import type { SliceStateFromReducer } from 'shared/types';

import type { mfoFormSlice } from 'entities/mfo/model/mfoForm.slice';

export type TPledgeEstateState = SliceStateFromReducer<typeof mfoFormSlice>;

export const selectMfoData = (state: TPledgeEstateState) => state.mfoForm.data;
